import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'

var messaging = new Messaging(new Logger(false));

const HUB_MESSAGING_SIMPLE = {
  takeOverHub: function (store, messageContext) {
    console.log("messageContext is", messageContext)
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_TAKE_OWNERSHIP,
      bodyContent: {
        password: messageContext.password
      }
    }
    if( messageContext.connectionType == 'Local' ){
      messageContextObject.connectionType = 'Local';
    }else if (messageContext.connectionType == 'Online' ){
      messageContextObject.connectionType = 'Online';
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  setHubAsSlave: function (store, messageContext) {
    console.log("messageContext is", messageContext)
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_SET_HUB_AS_SLAVE,
      bodyContent: {
        masterUUID: messageContext.masterUUID,
      }
    }
    // if( messageContext.connectionType == 'Local' ){
    //   messageContextObject.connectionType = 'Local';
    // }else if (messageContext.connectionType == 'Online' ){
    //   messageContextObject.connectionType = 'Online';
    // }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  loginUserToHub: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_USER_LOGIN,
      bodyContent: messageContext.bodyContent,
    }
    if( messageContext.connectionType == 'Local' ){
      messageContextObject.connectionType = 'Local';
    }else if (messageContext.connectionType == 'Online' ){
      messageContextObject.connectionType = 'Online';
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  registerNode: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_REGISTER_NODE,
      bodyContent: {
        deviceUUID: messageContext.nodeUUID,
        deviceType: messageContext.deviceType,
        hubUUID: messageContext.hubUUID,
        fallbackKey: messageContext.nodeFallbackKey,
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  pairNode: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_PAIR_NODE,
      bodyContent: {
        nodeUUID: messageContext.nodeUUID
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  setInstructionsOnDevice: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_SET_NODE_INSTRUCTIONS,
      bodyContent: {
        nodeUUID: messageContext.nodeUUID,
        instructionCount: messageContext.instructions.length,
        instructionList: messageContext.instructions
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  setInstructionsOnHub: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_SET_HUB_INSTRUCTIONS,
      bodyContent: {
        instructionList: messageContext.instructions
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  removeHubInstruction: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_REMOVE_HUB_INSTRUCTION,
      bodyContent: {
        instructionList: messageContext.instructions
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  addHubScenario: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_ADD_HUB_SCENARIO,
      bodyContent: {
        scenarioList: messageContext.scenarios
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  removeHubScenario: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_REMOVE_HUB_SCENARIO,
      bodyContent: {
        scenarioList: messageContext.scenarios
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  addInstructionsOnHub: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_ADD_HUB_INSTRUCTIONS,
      bodyContent: {
        instructionCount: messageContext.instructions.length,
        instructionList: messageContext.instructions
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  readHubInstructions: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_READ_HUB_INSTRUCTIONS,
      bodyContent: {}
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  getHubScenarios: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_GET_HUB_SCENARIOS,
      bodyContent: {}
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  readNodeInstructions: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_READ_NODE_INSTRUCTIONS,
      bodyContent: {
        nodeUUID: messageContext.nodeUUID
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  deleteDevice: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_REMOVE_NODE,
      bodyContent: {
        nodeUUID: messageContext.nodeUUID
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  readHubParameters: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_READ_HUB_PARAMETERS,
      bodyContent: {
      }
    }
    if( messageContext.connectionType == 'Local' ){
      messageContextObject.connectionType = 'Local';
    }else if (messageContext.connectionType == 'Online' ){
      messageContextObject.connectionType = 'Online';
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  setHubTime: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_SET_HUB_TIME,
      bodyContent: messageContext.bodyContent
    }
    if( messageContext.connectionType == 'Local' ){
      messageContextObject.connectionType = 'Local';
    }else if (messageContext.connectionType == 'Online' ){
      messageContextObject.connectionType = 'Online';
    }
    console.log('setHubTime messageContextObject', messageContextObject)
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  getNodeListAndStates: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_GET_NODES_LIST,
      bodyContent: {
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  readNodeParameters: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_READ_NODE_PARAMETERS,
      bodyContent: {
        nodeUUID: messageContext.nodeUUID
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  setNodesParameters: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_SEND_COMMAND,
      bodyContent: messageContext.bodyContent,
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  requestOtaUpdate: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_OTA_UPDATE_COMMAND,
      bodyContent: {
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  scanWiFiNetworks: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_WIFI_SCAN,
      bodyContent: {
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  setHubWifi: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_WIFI_CONFIG,
      bodyContent: messageContext.bodyContent,
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  getUserList: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_GET_USERS_LIST,
      bodyContent: {
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  addUserToHub: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_NEW_USER,
      bodyContent: messageContext.bodyContent,
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  deleteUserFromHub: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_REMOVE_USER,
      bodyContent: messageContext.bodyContent,
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  readHubWatches: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_READ_PARAMETER_WATCHES,
      bodyContent: {},
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  readHubSchedules: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_READ_HUB_SCHEDULES,
      bodyContent: {},
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  setWatchOnHub: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_SET_PARAMETER_WATCHES,
      bodyContent: messageContext.bodyContent,
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  setHubSchedules: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_SET_HUB_SCHEDULES,
      bodyContent: messageContext.bodyContent,
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  setEventMasks: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_SET_EVENT_MASKS,
      bodyContent: messageContext.bodyContent,
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  getEventMasks: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_GET_EVENT_MASKS,
      bodyContent: {},
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  setUplinkImitator: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_SET_UPLINK_IMITATORS,
      bodyContent: {
        imitatorsList: messageContext.imitatorsList
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  getUplinkImitators: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_GET_UPLINK_IMITATORS,
      bodyContent: {},
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  modifyParameterWatches: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_MODIFY_PARAMETER_WATCHES,
      bodyContent: messageContext.bodyContent,
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  modifyHubInstructions: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_MODIFY_HUB_INSTRUCTIONS,
      bodyContent: {
        instructionCount: messageContext.instructions.length,
        instructionList: messageContext.instructions
      }
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  deleteHubInstructionsByEventId: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_DELETE_HUB_INSTRUCTIONS_BY_EVENT_ID,
      bodyContent: messageContext.bodyContent,
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  setEventNotifications: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_SET_EVENT_NOTIFICATIONS,
      bodyContent: messageContext.bodyContent,
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
  readEventNotifications: function (store, messageContext) {
    var messageContextObject = {
      messagingHook: messageContext.messagingHook,
      hubUUID: messageContext.hubUUID,
      messageType: messaging.UPLINK_PACKET_READ_EVENT_NOTIFICATIONS,
      bodyContent: {},
    }
    return store.dispatch('sendMessageToHub', messageContextObject);
  },
}
export default HUB_MESSAGING_SIMPLE;